import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'carriers-benefits-popup',
	template: `
		<div class="carriers-wrapper">
			<h1>Carrier features & benefits</h1>
			<div class="carriers-container">
				<div class="carrier" *ngFor="let carrier of control.attributes.carriers">
					<img class="logo" [src]="carrier.imageUrl" />
					<ul *ngFor="let benefit of carriersFeatures[carrier.name]">
						<li>{{ benefit }}</li>
					</ul>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./carriers-benefits-popup.component.scss'],
})
export class CarriersBenefitsPopupComponent extends BaseComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}
	carriersFeatures = {
    Nationwide: ['Identity Theft', 'Home purchase discount', 'Equipment breakdown endorsement'],
		NationalGeneral: ['Advanced quote discount', 'No limit on age of home', 'Service line endorsement'],
		Homesite: [
			'Advanced shopping discount (excluded in AR)',
			'Will accept roofs of any age (check KMS for settlement options)',
			'Will accept all dog breeds',
		],
		ASI: [
			'Non-smoking discount',
			'Single deductible advantage',
			'First time home buyers/New purchase discounts (excluded in DC & ID)',
		],
		Foremost: [
			'Will Accept Roofs of Any Age (check KMS in settlement options)',
			'Equipment Breakdown Endorsement',
			'Will Accept All Dog Breeds',
		],
    PlymouthRock: ['Advanced Quote Discount', 'Service Line Endorsement', 'Will Accept All Dog Breeds'],
    HippoD2C: [
      '4X higher coverage limits for computers and home office equipment.',
      'Access to Home Care: personalized home maintenance checklists & guides.',
      'Smart Home systems to help you protect your home.',
    ],
    Openly: [
      'Written on an enhanced HO5 form, giving more coverage than the standard HO3 including Guaranteed Replacement Cost up to $5 million.',
      'Up to $1M of Liability.',
      'Increased water backup coverage all the way to 100% of replacement cost.',
    ],
    TowerHill: [
      'CyberShield packages.',
      'Equipment Breakdown and Service Line.',
      'Available credits include water-sensor, gated community, alarm, and senior credit for members 60+.',
      'CastleCare, preferred vendor service for when repairs or rebuilding are necessary due to a covered loss.',
    ],
    AII: ['Protective Device Discounts', 'Secured Community Discounts'],
    True: [
      'Wind Mitigation Discount',
      'Progressive Auto Companion Discount*',
      'A la carte coverage options for customization'],
	};

	ngOnInit() {}
}
